import './App.css';
import Navbar from './components/navbar';
import Nosotros from './pages/nosotros';
import Fundadores from './pages/fundadores';
import Catalogo from './pages/catalogo';
import Contacto from './pages/contacto';
import ScrollToTop from './components/scrolltop';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'; // 👈 agrega Navigate

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        <Routes>
          <Route path="/" element={<Navigate to="/nosotros" replace />} />
          
          <Route path="/nosotros" element={<Nosotros />} />
          <Route path="/fundadores" element={<Fundadores />} />
          <Route path="/catalogo" element={<Catalogo />} />
          <Route path="/contacto" element={<Contacto />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;